/**
 * Base URL des routes FastAPI (…/api/...).
 *
 * Développement : URL absolue vers le backend.
 *   REACT_APP_BACKEND_URL dans .env.development.local (recommandé : http://127.0.0.1:8000).
 *   Sans variable : si la page est sur localhost ou 127.0.0.1 → même hôte :8000 ;
 *   sinon (ex. ouverture via IP LAN 192.168.*) → http://127.0.0.1:8000/api car uvicorn
 *   écoute en général sur la loopback uniquement.
 *
 * Production : REACT_APP_BACKEND_URL au build si besoin ; sinon `/api` (reverse proxy nginx / Docker).
 */
function normalizeBackendRoot(base) {
  const s = String(base).replace(/\/$/, '');
  return s.endsWith('/api') ? s : `${s}/api`;
}

function devApiBase() {
  const base = process.env.REACT_APP_BACKEND_URL;
  if (base && base !== 'undefined') {
    return normalizeBackendRoot(base);
  }
  if (typeof window !== 'undefined') {
    const { protocol, hostname } = window.location;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return `${protocol}//${hostname}:8000/api`;
    }
    return 'http://127.0.0.1:8000/api';
  }
  return 'http://127.0.0.1:8000/api';
}

function apiBase() {
  if (process.env.NODE_ENV === 'development') {
    return devApiBase();
  }

  const base = process.env.REACT_APP_BACKEND_URL;
  if (base && base !== 'undefined') {
    return normalizeBackendRoot(base);
  }
  return '/api';
}

export const API = apiBase();
